import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/table_no_content.svg")